import { createSagas } from "redux-box";
import { call, put } from "redux-saga/effects";
import swal from "sweetalert2";
import api from "@s/api/wordgame";

export default createSagas({
  REQUEST_WORDS: function* ({ offset, search, gradeId }) {
    try {
      yield put({ type: "SET_LOADING", isLoading: true });

      let filterString = "";
      if (search) filterString += `&search=${encodeURIComponent(search)}`;
      if (gradeId) filterString += `&grade_id=${gradeId}`;

      const response = yield call(api.getWords, offset, filterString);
      if (response) {
        yield put({ type: "SET_WORDS", words: response.result || [] });
        yield put({
          type: "SET_PAGINATION",
          pagination: {
            count: response.count,
            next_page: response.next_page,
            prev_page: response.prev_page,
            offset: response.offset,
            has_next: response.has_next,
          },
        });
      }
    } catch (err) {
      console.error("wordgame/REQUEST_WORDS error:", err);
      swal("Error", "Failed to load words", "error");
    } finally {
      yield put({ type: "SET_LOADING", isLoading: false });
    }
  },

  CREATE_WORD: function* ({ payload }) {
    try {
      yield call(api.createWord, payload);
      swal("Success", "Word created successfully", "success");
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "REQUEST_WORDS", offset: 0, search: "", gradeId: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to create word";
      swal("Error", msg, "error");
    }
  },

  UPDATE_WORD: function* ({ id, payload }) {
    try {
      yield call(api.updateWordById, id, payload);
      swal("Success", "Word updated successfully", "success");
      yield put({ type: "HIDE_MODAL" });
      yield put({ type: "REQUEST_WORDS", offset: 0, search: "", gradeId: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to update word";
      swal("Error", msg, "error");
    }
  },

  DELETE_WORD: function* ({ id }) {
    try {
      yield call(api.deleteWordById, id);
      swal("Success", "Word deleted successfully", "success");
      yield put({ type: "REQUEST_WORDS", offset: 0, search: "", gradeId: "" });
    } catch (err) {
      const msg = err && err.error_message ? err.error_message : "Failed to delete word";
      swal("Error", msg, "error");
    }
  },
});
